import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import CalloutBoxPlot from 'components/molecules/charts/CalloutBoxPlot';
import ExportableCalloutWithBoxPlot from 'containers/callouts/ExportableCalloutWithBoxPlot';
import { formatNumbers } from 'helpers/formatNumbers';
import { getHelpText } from 'helpers/glossary';
import ContentTile from 'components/atoms/layout/ContentTile';
import CallOutWrapper from 'components/atoms/callout/CallOutWrapper';
import Title from 'components/atoms/callout/Title';
import Value from 'components/atoms/callout/Value';
import {
    HelpBox,
    HelpClose,
    HelpBody,
    HelpTitle,
    HelpIcon,
} from 'components/atoms/callout/Help';
import {
    BoxPlotWrapper,
    CategoriesWrapper,
} from 'components/atoms/callout/SparkLine';

class CallOutValueWithBoxPlot extends Component {
    constructor(props) {
        super(props);
        this.state = { toggleHelp: false };
        this.toggleHelp = this.toggleHelp.bind(this);
    }

    toggleHelp() {
        this.setState({ toggleHelp: !this.state.toggleHelp });
    }

    render() {
        const { value } = this.props;
        const valueDisplay = formatNumbers(value, this.props.format);
        const helpText = getHelpText({ glossaryKey: this.props.type });

        const boxPlot = this.props.boxPlot || false;
        const categories = [
            formatNumbers(boxPlot.min, this.props.format),
            formatNumbers((boxPlot.min + boxPlot.max) / 2, this.props.format),
            formatNumbers(boxPlot.max, this.props.format)
        ].map((d, index) => <span key={index}>{d}</span>);

        return (
            <ContentTile>
                <CallOutWrapper data={this.props.data}>
                    <Value>{valueDisplay}</Value>
                    <Title>{this.props.title}</Title>
                    <HelpIcon className="icon-help-circle" onClick={this.toggleHelp.bind(this)} />
                    {boxPlot ?
                        <React.Fragment>
                            <BoxPlotWrapper>
                                <CalloutBoxPlot data={boxPlot} labelTitle={this.props.title} exportName={`${this.props.exportName}-boxplot`} />
                            </BoxPlotWrapper>
                            <CategoriesWrapper style={{ borderTop: '1px solid #B3B3B3' }}>{categories}</CategoriesWrapper>
                        </React.Fragment>
                        : null}
                    <HelpBox
                        onClick={this.toggleHelp.bind(this)}
                        className={this.state.toggleHelp ? 'show-help' : 'hide-help'} >
                        <HelpTitle>{this.props.title}</HelpTitle>
                        <HelpBody>{helpText}</HelpBody>
                        <HelpClose className="icon-close-circle"/>
                    </HelpBox>
                    <ExportableCalloutWithBoxPlot
                        exportName={this.props.exportName}
                        title={this.props.title}
                        value={valueDisplay}
                        seriesData={boxPlot} />
                </CallOutWrapper>
            </ContentTile>
        );
    }
}

CallOutValueWithBoxPlot.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
        value: PropTypes.number.isRequired,
        change: PropTypes.number,
        completeData: PropTypes.bool,
        calloutWindow: PropTypes.number.isRequired
    }),
    format: PropTypes.string,
    invert: PropTypes.bool
};

export default withTheme(CallOutValueWithBoxPlot);



// WEBPACK FOOTER //
// ./src/components/molecules/CallOutValueWithBoxPlot.js